import qs from 'qs';

import client from 'api/client';
import { InvoiceResponse } from 'api/models/response/Invoices';

export function get(filters?: unknown) {
    const queryParams = qs.stringify(filters, { skipNulls: true });
    return client.get<InvoiceResponse[]>(`/invoices?${queryParams}`);
}
